module.exports = __webpack_public_path__ + "assets/videos/floorplan/floorplan-2020/0008.jpg?v=381b3a00";